import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { CoreService } from '../core.service'
import { PurchaseExport } from 'depoto-core/src/entities'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class PurchaseExportService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  async getPurchaseExport(
    // todo
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<{
    items: PurchaseExport[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.purchaseExport.getList(parameters, schema)
  }

  createPurchaseExport(
    purchaseExport: PurchaseExport | Partial<PurchaseExport>,
    schema: PurchaseExport | Partial<PurchaseExport>
  ): Promise<PurchaseExport | Partial<PurchaseExport>> {
    return this.core.services.purchaseExport.create(purchaseExport as any, schema as any)
  }

  // updateCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {y
  //     return this.core.services.checkout.updateWithTanstack(checkout, schema)
  // }

  // deletepurchaseExport(purchaseExport: Partial<purchaseExport>): Promise<purchaseExport> {todo
  //   return this.core.services.purchaseExport.dele(purchaseExport)
  // }
}
